var _rect, _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditCandidateMobile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    rx: 9,
    fill: "#F2F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.4375H9.5625C9.26413 8.4375 8.97798 8.55603 8.767 8.767C8.55603 8.97798 8.4375 9.26413 8.4375 9.5625V17.4375C8.4375 17.7359 8.55603 18.022 8.767 18.233C8.97798 18.444 9.26413 18.5625 9.5625 18.5625H17.4375C17.7359 18.5625 18.022 18.444 18.233 18.233C18.444 18.022 18.5625 17.7359 18.5625 17.4375V13.5",
    stroke: "#6866FF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0862 8.22669C17.31 8.00291 17.6135 7.8772 17.93 7.8772C18.2465 7.8772 18.55 8.00291 18.7737 8.22669C18.9975 8.45047 19.1232 8.75397 19.1232 9.07044C19.1232 9.38691 18.9975 9.69041 18.7737 9.91419L13.7039 14.9846C13.5704 15.118 13.4053 15.2157 13.2241 15.2686L11.608 15.7411C11.5596 15.7552 11.5083 15.7561 11.4595 15.7436C11.4107 15.7311 11.3661 15.7057 11.3304 15.67C11.2948 15.6343 11.2694 15.5898 11.2568 15.5409C11.2443 15.4921 11.2452 15.4408 11.2593 15.3924L11.7318 13.7763C11.785 13.5952 11.8828 13.4304 12.0164 13.2971L17.0862 8.22669Z",
    stroke: "#6866FF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCandidateMobile);
export default __webpack_public_path__ + "static/media/editCandidateMobile.e955b940252aee1163a061cbd1aca6db.svg";
export { ForwardRef as ReactComponent };